import styled from "styled-components";
import { getFontSize } from "utils/text-styles";

export const Input = styled.input`
  border: 1px solid ${(props) => props.theme.theme.DIVIDER_COLOR};
  color: ${(props) => props.theme.theme.INPUT.TEXT_COLOR} !important;
  background-color: ${(props) => props.theme.theme.INPUT.BACKGROUND} !important;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  font-size: ${(props) => getFontSize(props.theme.fontSize)} !important;
  border-radius: 0.25rem;
  padding: 0.375rem 0.75rem;
  display: block;
  width: 100%;
  max-width: 350px;

  &.w-100 {
    max-width: 100%;
  }

  @media (max-width: 768px) {
    max-width: 100%;
  }

  &:focus {
    border-color: #80bdff;
    background-color: ${(props) => props.theme.theme.INPUT.BACKGROUND};
    outline: 0;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
  }
`;

export const Select = styled.select`
  border: 1px solid ${(props) => props.theme.theme.DIVIDER_COLOR};
  color: ${(props) => props.theme.theme.INPUT.TEXT_COLOR} !important;
  background-color: ${(props) =>
    props.theme.theme.SELECT.INPUT.BACKGROUND} !important;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  font-size: ${(props) => getFontSize(props.theme.fontSize)} !important;
  border-radius: 0.25rem;

  &:focus {
    border-color: #80bdff;
    background-color: ${(props) => props.theme.theme.INPUT.BACKGROUND};
    outline: 0;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
  }
`;

export const Option = styled.option`
  color: ${(props) => props.theme.theme.INPUT.TEXT_COLOR} !importante;
  background-color: ${(props) => props.theme.theme.INPUT.BACKGROUND};
`;
